// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"291":"fba9c01a","966":"fba9c01a"}[chunkId] + ".chunk.css";
};